<!-- @format -->

<template>
	<div>
		<!--顶部状态栏-->
		<Topbar v-bind="extendData" v-on:showDefectPoints="showDefectPoints = true" :sideIndex="sideIndex" v-on:hideDefectPoints="showDefectPoints = false" v-on:showRuleBar="showRuleBar = true" v-on:hideRuleBar="showRuleBar = false" :modelSides="modelSides" v-on:changeModeSideIndex="changeModeSideIndex" />
		<!--图像展示区-->
		<div class="top">
			<ImageView v-bind:imageUri="originalImageBase64" v-bind:defectRect="defectRect" v-bind:showPoints="showDefectPoints" v-bind:pointsData="pointsData" v-on:selectRect="selectRect" v-on:selectComplete="imageViewSelect" :totalLength="totalLength" :defectSign="defectSign" :showRuleBar="showRuleBar" />
		</div>
		<!--缺陷记录区-->
		<div class="bottom">
			<ReferenceImage class="reference_view" v-bind:image1="referenceImage" v-bind:image2="defectImage" v-bind:defectSize="defectSize" v-on:changeLayout="changeLayout" />

			<div id="defectList" class="defectList" :style="{ left: leftclientWidth }">
				<defect-list v-bind:batchInfo="batchInfo" v-bind:modelSides="modelSides" v-bind:items="defects" v-bind:batch_id="batch_id" v-bind:tableHeight="tableHeight" v-bind:selectionArea="selectionArea" v-on:rowClick="defectListRowClick" v-on:changeFilterStatus="changeFilterStatus" v-on:changeSurface="changeSurface" />
			</div>
		</div>
	</div>
</template>

<script>
	import ImageView from '@/components/browser/ImageView'
	import instance from 'axios'
	import Topbar from '@/components/browser/Topbar'
	import ReferenceImage from '@/components/browser/ReferenceImage'
	import { defectStatisRequest } from '@/network/requests/defectStatis'
	import { getDefectRequest, getDefectImageUrlByMd5 } from '@/network/requests/defect'
	import { defectTypeRequest } from '@/network/requests/defectType'
	import { modelRequest } from '@/network/requests/model'
	import { modelSideRequest } from '@/network/requests/modelSide'
	import { modelSideImageRequest, getModelSideImageUrlByFileId } from '@/network/requests/modelSideImage'
	import { jtInfoRequest, getJTIdNameMap } from '@/network/requests/jtInfo'
	import { productRequest } from '@/network/requests/product'

	export default {
		components: {
			ImageView,
			Topbar,
			ReferenceImage,
			DefectList: resolve => {
				require(['@/components/browser/List'], resolve)
			},
		},
		data() {
			return {
				leftclientWidth: (document.body.clientHeight - 350) / 2 + 'px',
				extendData: {},
				originalImageBase64: '',
				batchInfo: {},
				tableHeight: 0,
				defectRect: null,
				totalLength: 0,
				defectSign: [],
				showDefectPoints: false,
				showRuleBar: true,
				pointsData: [],
				defectImage: '',
				referenceImage: '',
				defectSize: [],
				selectionArea: [],
				modelSides: [],
				modelSideImages: [],
				/**
				 * 批次Id，需要从URL获取。
				 */
				batch_id: this.$route.query.batch_id,
				/**
				 * 缺陷集合。
				 */
				defects: [],
				/**
				 * 批次所有模板(版图)。
				 */
				models: [],
				sideIndex: 0,
			}
		},
		methods: {
			async changeSurface(value) {
				var md = this.modelSides.find(t => t.side_index == value)
				if (!md) {
					return
				}

				console.log('修改版图。')
				console.log('md', md)

				var msi = this.modelSideImages.find(t => t.model_side_id == md._id.$oid)
				if (msi) {
					//获取版图的 restHeart 的url。
					var url = getModelSideImageUrlByFileId(msi.file_id)
					//对 hostmain 进行修改，已方便通过代理的方式访问图片。
					this.originalImageBase64 = window.location.protocol + '//' + window.location.host + url

					console.log('当前版图', this.originalImageBase64)
				}
				//加载缺陷记录。
				await this.loadDefects(value)
			},
			/**
			 *
			 */
			changeModeSideIndex(index) {
				var md = this.modelSides.find(t => t.side_index == index)
				if (!md) {
					return
				}

				var msi = this.modelSideImages.find(t => t.model_side_id == md._id.$oid)
				if (msi) {
					//获取版图的 restHeart 的url。
					var url = getModelSideImageUrlByFileId(msi.file_id)
					//对 hostmain 进行修改，已方便通过代理的方式访问图片。
					this.originalImageBase64 = window.location.protocol + '//' + window.location.host + url

					console.log('当前版图', this.originalImageBase64)
				}
			},
			/**
			 * 修改版图。
			 */
			changeLayout() {
				console.log('修改版图啊')
			},
			/**
			 * 点击缺陷记录事件。
			 */
			async defectListRowClick(data) {
				console.log('点击缺陷记录', data)

				this.sideIndex = data.side_index

				//切换版图。
				await this.changeSurface(data.side_index)

				//在图片中显示该区域。
				this.defectRect = {
					x: data.pos_x,
					y: data.pos_y,
					h: data.size_cy,
					w: data.size_cx,
					type: 1,
				}

				this.defectSize = [data.size_cx, data.size_cy]
				this.defectImage = getDefectImageUrlByMd5(data.md5, this.batch_id)
			},
			/**
			 * 当图像中显示缺陷图时，返回版图中的参考图。
			 */
			selectRect(imageUri) {
				//将参考图进行赋值。
				this.referenceImage = imageUri
			},
			/**
			 * 当选择区域结束时触发。
			 */
			imageViewSelect(rect) {
				console.log('选择结束：', rect)
				var x1,
					y1,
					x2,
					y2 = ''

				x1 = String(rect.x1.toFixed(0))
				x2 = String(rect.x2.toFixed(0))
				y1 = String(rect.y1.toFixed(0))
				y2 = String(rect.y2.toFixed(0))

				if (rect.x1 == rect.x2) {
					x1 = x2 = ''
				}

				if (rect.y1 == rect.y2) {
					y1 = y2 = ''
				}

				this.selectionArea = [x1, y1, x2, y2]
			},
			/**
			 * 修改筛选状态。
			 */
			changeFilterStatus(val) {
				console.log('this.batchInfo', this.batchInfo)
				if (this.batchInfo.filter_status == val) return

				//修改筛选状态。
				this.batchInfo.filter_status = val

				if (val == 1) {
					//修改筛选时间。
					this.batchInfo.filter_time = {
						$date: new Date().getTime(),
					}
				}

				defectStatisRequest.modifyById(this.batch_id, this.batchInfo)
			},
			/**
			 * 加载所有缺陷记录。
			 */
			async loadDefects(side_index) {
				var items = []
				//获取所有缺陷信息。--{ side_index: side_index }
				var array = await getDefectRequest(this.batch_id).queryAll(undefined, undefined, { side_index: 1 }, 1000)

				array.forEach(element => {
					var p = { ...element }

					//减去偏移量。
					p.pos_x = p.pos_x - 143

					items.push(p)
				})

				this.defects = items

				this.defectSign = this.defects
					.map(p => p.meter / 1000)
					.sort((a, b) => {
						return a - b
					})
				this.pointsData = this.defects.map(p => {
					return {
						id: p._id.$oid,
						x: p.pos_x + p.size_cx / 2,
						y: p.pos_y + p.size_cy / 2,
					}
				})
			},
		},
		async created() {
			//获取批次信息。
			this.batchInfo = (await defectStatisRequest.getDocumentById(this.batch_id)).data
			this.totalLength = this.batchInfo.total_len / 1000

			console.log('this.totalLength', this.batchInfo.total_len / 1000)

			//获取批次所有的模板。
			var model = (await modelRequest.queryAll({ roll_id: this.batch_id }))[0]

			if (model) {
				//检测面。
				this.modelSides = await modelSideRequest.queryAll({ model_id: model._id.$oid }, undefined, { side_index: 1 })
				//检测面图片。
				this.modelSideImages = await modelSideImageRequest.queryAll({ model_id: model._id.$oid })

				var side_index = this.modelSides[0].side_index

				this.changeSurface(side_index)
			} else {
				this.$message.error('没有该批次对应的版图信息,因此无法加载数据')
			}

			this.extendData.batch_name = this.batchInfo.roll_code
			this.extendData.jt_name = (await getJTIdNameMap(this.batchInfo.jt_id)).get(this.batchInfo.jt_id)
			this.extendData.product_name = '--'

			console.log('this.extendData', this.extendData)

			//产品信息。
			if (this.batchInfo.product_id) {
				this.extendData.product_id = this.batchInfo.product_id
			}
		},
		mounted() {
			//计算表格高度。
			this.tableHeight = document.getElementById('defectList').offsetHeight
		},
	}
</script>

<style scoped>
	body {
		overflow: hidden;
	}

	.top,
	.bottom {
		position: absolute;
	}

	.top {
		left: 0;
		top: 30px;
		right: 0;
		height: 320px;
		background-color: rgb(127, 127, 127);
		border-bottom: 1px #000 solid;
	}

	.bottom {
		bottom: 0;
		left: 0;
		right: 0;
		top: 350px;
		background-color: #eee;
	}

	.defectList {
		position: absolute;
		bottom: 2px;
		right: 0;
		top: 10px;
		/* left: 330px; */
	}

	.reference_view {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		padding: 10px 0 0 5px;
	}
</style>
